import React from "react";

class ViewSingleSite extends React.Component {
  render() {
    const { data, title } = this.props;

    return (
      <>
        {data ? (
          <div className="content-form-block light-gray-bg">
            <h3 className="text-center mb-4">{title}</h3>
            <p>
              <strong>Job ID : </strong>
              {data.job_id}
            </p>
            <p>
              <strong>Event : </strong> {data.event}
            </p>
            <p>
              <strong>Created At : </strong>
              {data.created_at}
            </p>
            <p>
              <strong>Updated At : </strong>
              {data.updated_at}
            </p>
            <p>
              <strong>Status : </strong>
              {data.status}
            </p>
            <p className="json-data">
              <strong>Response : </strong>
              <pre>{JSON.stringify(data.response, null, 2)}</pre>
            </p>
          </div>
        ) : (
          <p>No data found</p>
        )}
      </>
    );
  }
}

export default ViewSingleSite;
